if (!customElements.get("quick-add-modal")) {
  customElements.define("quick-add-modal", class QuickAddModal extends ModalDialog {
    constructor() {
      super();
      this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

      window.addEventListener("keyup", (event) => {
        if (event.code.toUpperCase() === "ESCAPE") this.hide();
      });

      window.addEventListener("resize", () => {
        document.querySelectorAll(".js-media-list").forEach((el) => { if (el.swiper) el.swiper.destroy(); });
        document.querySelectorAll(".js-media-sublist").forEach((el) => { if (el.swiper) el.swiper.destroy(); });
        setTimeout(() => {
          if (typeof subSliderInit === 'function') subSliderInit(true, 8);
          if (typeof sliderInit === 'function') sliderInit(true);
        }, 200);
      });
    }

    hide(preventFocus = false) {
      var cartDrawer = document.querySelector("cart-drawer");
      if (cartDrawer) cartDrawer.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = "";

      document.querySelectorAll(".js-media-list").forEach((el) => { if (el.swiper) el.swiper.destroy(); });
      document.querySelectorAll(".js-media-sublist").forEach((el) => { if (el.swiper) el.swiper.destroy(); });

      if (typeof subSliderInit === 'function') subSliderInit(true, 8);
      if (typeof sliderInit === 'function') sliderInit(true);

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute("aria-disabled", true);
      opener.classList.add("loading");
      if (opener.querySelector(".loading-overlay__spinner")) {
        opener.querySelector(".loading-overlay__spinner").classList.remove("hidden");
      }

      fetch(opener.getAttribute("data-product-url"))
        .then((response) => response.text())
        .then((responseText) => {
          var responseHTML = new DOMParser().parseFromString(responseText, "text/html");
          this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
          this.preventDuplicatedIDs();
          this.removeDOMElements();
          this.setInnerHTML(this.modalContent, this.productElement.innerHTML, opener);

          if (window.Shopify && Shopify.PaymentButton) Shopify.PaymentButton.init();
          if (window.ProductModel) window.ProductModel.loadShopifyXR();

          this.updateImageSizes();
          this.preventVariantURLSwitching();
          super.show(opener);
        })
        .finally(() => {
          opener.removeAttribute("aria-disabled");
          opener.classList.remove("loading");
          if (opener.querySelector(".loading-overlay__spinner")) {
            opener.querySelector(".loading-overlay__spinner").classList.add("hidden");
          }

          document.querySelectorAll(".js-media-list").forEach((el) => { if (el.swiper) el.swiper.destroy(); });
          document.querySelectorAll(".js-media-sublist").forEach((el) => { if (el.swiper) el.swiper.destroy(); });

          if (typeof subSliderInit === 'function') subSliderInit(true, 8);
          if (typeof sliderInit === 'function') sliderInit(true);
        });
    }

    setInnerHTML(element, html, opener) {
      element.innerHTML = html;
      element.querySelectorAll("script").forEach((oldScriptTag) => {
        var newScriptTag = document.createElement("script");
        Array.from(oldScriptTag.attributes).forEach((attr) => newScriptTag.setAttribute(attr.name, attr.value));
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });

      var moreBtn = document.createElement("a");
      moreBtn.innerHTML = '<span>' + (window.theme ? window.theme.quickviewMore : 'View more') + '</span><svg class="icon icon-button-arrow" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.30644 5.5C6.89223 5.5 6.55644 5.83579 6.55644 6.25C6.55644 6.66421 6.89223 7 7.30644 7L12.5669 7L5.5976 13.9693C5.30471 14.2622 5.30471 14.7371 5.5976 15.0299C5.89049 15.3228 6.36537 15.3228 6.65826 15.0299L13.6275 8.06069V13.3211C13.6275 13.7353 13.9633 14.0711 14.3775 14.0711C14.7917 14.0711 15.1275 13.7353 15.1275 13.3211V6.25C15.1275 6.14102 15.1043 6.03747 15.0625 5.94404C15.034 5.88021 14.9961 5.81955 14.9489 5.76414C14.8817 5.68521 14.7985 5.62038 14.7042 5.5747C14.6055 5.52684 14.4946 5.5 14.3775 5.5H7.30644Z" fill="currentColor"/></svg>';
      moreBtn.setAttribute("href", opener.getAttribute("data-product-url"));
      moreBtn.setAttribute("class", "product__full-details button button--simple button--arrow");

      var buttons = element.querySelector(".product-form__buttons");
      if (buttons) buttons.appendChild(moreBtn);
    }

    removeDOMElements() {
      [".product-popup", ".about", ".share-buttons", ".product__sku",
       ".breadcrumb", ".product-tags", ".pickup-availability",
       ".product__text-icons", ".product__description", ".product-recommendations"
      ].forEach((sel) => {
        this.productElement.querySelectorAll(sel).forEach((el) => el.remove());
      });
    }

    preventDuplicatedIDs() {
      var sectionId = this.productElement.dataset.section;
      this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, "quickadd-" + sectionId);
      this.productElement.querySelectorAll("variant-selects, variant-radios").forEach((vs) => {
        vs.dataset.originalSection = sectionId;
      });
    }

    preventVariantURLSwitching() {
      var variantEl = this.modalContent.querySelector("variant-radios, variant-selects");
      if (variantEl) variantEl.setAttribute("data-update-url", "false");
    }

    updateImageSizes() {
      var product = this.modalContent.querySelector(".product");
      if (!product || !product.classList.contains("product--columns")) return;
      var mediaImages = product.querySelectorAll(".product__media img");
      if (!mediaImages.length) return;
      var mediaImageSizes = "(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)";
      if (product.classList.contains("product--medium")) mediaImageSizes = mediaImageSizes.replace("715px", "605px");
      else if (product.classList.contains("product--small")) mediaImageSizes = mediaImageSizes.replace("715px", "495px");
      mediaImages.forEach((img) => img.setAttribute("sizes", mediaImageSizes));
    }
  });
}
